module.exports = __webpack_public_path__ + "static/media/sort-down.47e31b21.svg";